export { default } from './PageMediaLibrary.vue'
